<template>
    <div class="sty-section grid grid__base" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="sty-section--showcase">
            <div class="grid--container">
                <sty-header>
                    <h3 class="u-reset u-reset__sty">
                        Container basics
                    </h3>
                </sty-header>
            </div>

            <div class="sty-section--example">
                <div class="grid--container sty-section--container">
                    <div class="sty-section--container-description">
                        <sty-header :facets="['grid']">
                            <span class="u-reset u-reset__sty-h4">
                                Container
                            </span>
                        </sty-header>
                    </div>

                    <div class="grid--row sty-section--row sty-section--row__basics">
                        <div class="grid--col sty-section--col sty-section--col__container-basics">
                            <div class="sty-section--content">
                                <sty-header :facets="['grid']">
                                    <span class="u-reset u-reset__sty-h4">
                                        Column
                                    </span>
                                </sty-header>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sty-section--example">
                <div class="grid--container grid--container__fluid sty-section--container">
                    <div class="grid--row sty-section--row sty-section--row__fluid-container">
                        <div class="grid--col">
                            <sty-header :facets="['grid']">
                                <span class="u-reset u-reset__sty-h4">
                                    Fluid Container
                                </span>
                            </sty-header>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sty-section--showcase">
            <div class="grid--container">
                <sty-header>
                    <h3 class="u-reset u-reset__sty">
                        Column setup
                    </h3>
                </sty-header>
            </div>

            <div class="grid--container sty-section--container">
                <div class="sty-section--outer-gutter-displayer"/>
                <div class="grid--row sty-section--row sty-section--row__column-setup">
                    <div class="grid--col sty-section--col" v-for="n in generateGridColumns(mq.width)" :key="n">
                        <div class="sty-section--inner-gutter-displayer"/>
                        <div class="sty-section--content">
                            <span class="sty-section--numbering" v-text="n"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import StyHeader from 'framework/styleguide/header';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import generateGridColumns from './helpers';

    export default {
        components: {
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('viewport', ['mq']),
        },
        methods: {
            generateGridColumns,
        },
    };
</script>
